import { FC, ReactElement, useEffect } from 'react';

import { Box, CssBaseline, Grid,Stack, Theme } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';

import { Navbar } from './navbar';
import { PalmPalette } from './PalmPalette';
import { TopPanel } from './toppanel/TopPanel';

type Props = {
  mode: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: ReactElement<any> | number | string;
};

const themes: { [key: string]: Theme } = {
    dark: createTheme(PalmPalette('dark')),
    light: createTheme(PalmPalette('light')),
};

const Layout: FC<Props> = ({ mode, children }) => {
    const theme = themes[mode];

    useEffect(() => {
        document.documentElement.style.colorScheme = mode === 'dark' ? 'dark' : 'light';
    }, [mode]);

    return (
        <ThemeProvider theme={theme}>
            <SnackbarProvider
                dense
                preventDuplicate
                maxSnack={3}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
            >
                <CssBaseline />
                <Box
                    data-testid="SiteWrappingBox"
                    sx={{
                        minWidth: '1330px',
                        backgroundColor: 'secondary.light',
                    }}
                >
                    <Grid container spacing={0}>
                        <Grid item sx={{ minWidth: '220px' }} xs={2}>
                            <Navbar />
                        </Grid>
                        <Grid item xs={10}>
                            <Stack
                                spacing={0}
                                justifyContent="flex-start"
                                alignItems="stretch"
                                height="100%"
                            >
                                <TopPanel />
                                <Box
                                    data-testid="mainWindow"
                                    id="mainWindow"
                                    sx={{
                                        width: '100%',
                                        backgroundColor: 'secondary.light',
                                        display: 'inline-block',
                                        color: 'secondary.dark',
                                        textAlign: 'center',
                                    }}
                                >
                                    {children}
                                </Box>
                            </Stack>
                        </Grid>
                    </Grid>
                </Box>
            </SnackbarProvider>
        </ThemeProvider>
    );
};

export { Layout };
